module.exports = __webpack_public_path__ + "static/media/ExpiredCycles.8d8ad506.svg";